import {Controller} from "stimulus";
import StimulusReflex from "stimulus_reflex";
import $ from "jquery";
import debounced from "debounced";
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";
import intlTelInput from 'intl-tel-input';

// Import TinyMCE
import tinymce from 'tinymce/tinymce'

// Import icons
import 'tinymce/icons/default/icons'

// Import theme
import 'tinymce/themes/silver/theme';

// Import skin
import 'tinymce/skins/ui/oxide/skin.min.css';

/* Import content css */
import contentUiCss from 'tinymce/skins/ui/oxide/content.css';
import contentCss from 'tinymce/skins/content/default/content.css';

/* tinymce langs */
//import 'tinymce/langs/fr_FR'

/* tinymce plugins */
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/help';
import 'tinymce/plugins/image';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/media';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/print';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/wordcount';

//require ('tui-time-picker/dist/tui-time-picker.css');
//require ("tui-calendar/dist/tui-calendar.css");

//import Calendar from "tui-calendar";

//select2 plugin
require("select2/dist/css/select2");
require("select2-bootstrap-theme/dist/select2-bootstrap");
import Select2 from "select2";

export default class extends Controller {
    connect() {

        // MicroModal.init();
        debounced.initialize({input: {wait: 900}});
        debounced.initialize({keyup: {wait: 900}});

        // this.initCheckbox()

        console.log("Application JS V2 en cours ...");

        StimulusReflex.register(this);
        tinymce.init({
            selector: '.tinymce',
            height: 500,
            menubar: true,
            skin: false,
            content_css: false,
            content_style: contentUiCss.toString() + "\n" + contentCss.toString(),
            plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount'
            ],
            toolbar: 'language' +
                'undo redo | formatselect | ' +
                ' bold italic backcolor | alignleft aligncenter ' +
                ' alignright alignjustify | bullist numlist outdent indent | ' +
                ' removeformat | help',
            /*content_langs: [
              { title: 'English', code: 'en_US' },
              { title: 'French', code: 'fr_FR' },
            ]*/
        });
        $(".nav-tabs li").click(function (e) {
            e.preventDefault();
            $(".nav-tabs li").removeClass('active');
            $(".nav-link").removeClass('active');
            $(this).addClass('active');
            $(this).find('a').addClass('active');
            let tid = $(this).find('a').attr('href');
            console.log("ID:" + tid);
            $('.tab-pane').removeClass('active in');
            $(tid).addClass('active in');
        });

        function templateResult(item, container) {
            // replace the placeholder with the break-tag and put it into an jquery object
            return $('<span>' + item.text.replace('[br]', '<br/>') + '</span>');
        }

        function templateSelection(item, container) {
            // replace your placeholder with nothing, so your select shows the whole option text
            return item.text.replace('[br]', '');
        }

        if ($(".content-search")) {
            $(".content-search").select2({
                width: "resolve",
                placeholder: "",
                allowClear: true,
                templateResult: templateResult,
                templateSelection: templateSelection
            });
        }
        this.load_show_edit_destroy();
        var self = this;
        this.initIntTel();

        function getParentsClassNames(elem, className) {
            var parents = [];
            while (
                elem.parentNode &&
                elem.parentNode.nodeName.toLowerCase() != "body"
                ) {
                elem = elem.parentNode;
                if (elem.className && elem.className.includes(className)) {
                    parents.push(elem.className);
                }
            }
            return parents;
        }


        document.addEventListener("click", function (evt) {
            let sidebar = document.getElementById("fx-sidebar-menu");
            if (!hasClass(sidebar, "fx-close")) {
                if (sidebar && (evt.target.style.zIndex < sidebar.style.zIndex)) {
                    sidebar.classList.toggle("fx-close");
                }
            }
            if (self.isopened == 1 && evt.target.id != "main") {
                let condition_select2 =
                    getParentsClassNames(evt.target, "select2").length == 0;
                let condition_flatpickr =
                    getParentsClassNames(evt.target, "flatpickr").length == 0;

                if (
                    document.getElementById("mySidebar") &&
                    evt.target.style.zIndex <
                    document.getElementById("mySidebar").style.zIndex &&
                    condition_flatpickr &&
                    condition_select2
                ) {
                    self.toggle();
                }
            } else {
            }
        });

        document.addEventListener("keydown", function (evt) {
            if (self.isopened == 1) {
                let code = evt.keyCode;
                if (code == 27) {
                    self.toggle();
                }
            }
        });

        function getCurrentHeight(ids) {
            let height = 0;
            for (var i = 0; i < ids.length; i++) {
                if (document.getElementById(ids[i])) {
                    height = height + document.getElementById(ids[i]).offsetHeight;
                }
            }
            return height;
        }

        function hasClass(element, className) {
            return (
                (" " + element.className + " ").indexOf(" " + className + " ") > -1
            );
        }

        // Récupération des éléments html qu'on aimerait manipuler dans la fontion documentIsCrolled par le biais de leur ID
        let navbar = document.getElementById("navbar");
        let cadre = document.getElementById("onglet-cadre");
        let btl = document.getElementById("barre-titre-liste");

        let quick_sort = document.getElementById("quick_sort");
        let search = document.getElementById("search");
        let main = document.getElementById("main");
        // let nav_bar_right_dd = document.getElementById("nav_bar_right_dd");
        let footerSection = $(".footer-section");


        // new code
        // let fx_list_height = $(".fx-list-idheight");
        // end new code
        if (main) {
            main.classList.add("openbtn_right");
        }
        //la ligne suivante  permet de savoir si l'utilisateur est en train de scroller la page
        $('#mySidebar #table_custom_ .switch input').each(function () {
            let me = $(this)
            if (me && (me.attr('type') === 'checkbox') && (me.attr('class').includes('preference_columns'))) {
                me[0].addEventListener("change", (e) => {
                    let hiddenHtmlClass = e.target.id.replace('filterrific_', '')
                    console.log(hiddenHtmlClass)
                    if (e.target.checked) {
                        console.log("show ", e.target)
                        $('.' + hiddenHtmlClass).show()
                    } else {
                        console.log("hide ", e.target)
                        $('.' + hiddenHtmlClass).hide()
                    }
                })
            }
        })
        /////
    }

    disconnect() {
        tinymce.remove()
    }


    introJsLunch(event) {
        var steps_js = eval(event.target.dataset.steps);
        steps_js = JSON.parse(steps_js);
        var new_steps = [];
        for (let i = 0; i < steps_js.length; i++) {
            if ($(steps_js[i].element).length > 0) {
                new_steps.push(steps_js[i]);
            }
        }
        steps_js = new_steps;
        var intro = introJs();
        intro.setOptions({
            steps: steps_js,
            nextLabel: event.target.dataset.next,
            prevLabel: event.target.dataset.prev,
            doneLabel: event.target.dataset.done,
            tooltipClass: 'customTooltip'
        });
        intro.start();
    }


    /**
     *
     * @param {element_id} string
     */


    setPositionOfIntTel(element_id) {
        element_id = "#" + element_id + " .intl-tel-wrapper"
        document.querySelectorAll(element_id).forEach(element => {

            this.toggleClassName(element, "p-absolute");

        });
    }


    /**
     *
     * @param {EventTarget} event

     *
     */

    slideToggle(event) {

        let element = document.getElementById("s" + event.target.id);

        this[element.style.height != "0px" ? "slideUp" : "slideDown"](element);
        this.toggleClassName(element.previousElementSibling, "active");

    }

    /**
     *
     * @param {HTMLElement} element
     * @returns {HTMLElement}
     *
     * Cett fonction prend en paramèttre un element html
     *Elle permet de cacher l'élment reçu en paramètre en dinimiuant sa hauteure jusqu'à 0px.
     */

    slideUp(element) {
        element.style.height = this.initHeight(element) + 2 + "px";
        setTimeout(() => {
            element.style.height = "0px";
            element.style.paddingTop = "0px";
            this.setPositionOfIntTel(element.id);
        }, 100);
    }

    /**
     *
     * @param {HTMLElement} element
     * @returns  {HTMLElement}
     * Cett fonction prend en paramèttre un élément html
     *Elle permet de faire apparaître l'elément html caché à l'aide de SlideUp.
     */

    slideDown(element) {
        element.style.paddingTop = "3px";
        element.style.height = this.initHeight(element) + 2 + "px";
        setTimeout(() => {
            element.style.height = "";
            this.setPositionOfIntTel(element.id);
        }, 600);

    }

    /**
     *
     * @param {HTMLElement} element
     * @returns elementHeight
     *
     * Elle permet de savoir la hauteur initiale de l'élément qu'on doit cacher où afficher
     */

    initHeight(element) {
        let elementHeight = 0;
        for (let i = 0; i < element.childElementCount; i++) {
            elementHeight =
                elementHeight < element.children[i].offsetHeight
                    ? element.children[i].offsetHeight
                    : elementHeight;
        }
        return elementHeight;
    }

    /**
     *
     * @param {HmlElemnt } element
     * @returns
     *
     * Cette fonction prend en paramètre un élément html,
     * elle permet d'ajouter ou de supprimer une classe de la classeList cet élément.
     */
    toggleClassName(element, className) {
        let h1_element = $(element);
        if (h1_element.attr("class").includes(className)) {
            h1_element.removeClass(className);
        } else {
            h1_element.addClass(className);
        }

        return h1_element;
    }


    initIntTel() {
        var inputPhones = document.querySelectorAll(".int-phone");
        var self = this;
        if (inputPhones) {
            inputPhones.forEach((phone, index) => {

                // here, the index maps to the error code returned from getValidationError - see readme
                var errorMap = ["Numéro invalide", "Indicatif du pays est invalide", "Trop court", "Trop long", "Numéro invalide"];


                if (phone) {
                    // initialise plugin
                    var iti = intlTelInput(phone, {
                        initialCountry: "fr",
                        formatOnDisplay: true,
                        separateDialCode: true,
                        customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                            // return "00 00 00 00 00";
                            return "e.g. " + selectedCountryPlaceholder;

                        },

                    });

                    var id_error = "error-msg_" + index,
                        id_valid = "valid-msg_" + index,
                        id_hidden_field = "tel_" + index;
                    var errorMsg = document.getElementById(id_error),
                        validMsg = document.getElementById(id_valid),
                        hidden_field = document.getElementById(id_hidden_field)
                    self.reset(errorMsg, validMsg, phone, hidden_field, iti);
                    // on blur: validate
                    phone.addEventListener('blur', function () {
                        self.reset(errorMsg, validMsg, phone, hidden_field, iti);
                        if (phone.value.trim()) {
                            if (iti.isValidNumber()) {
                                validMsg ? validMsg.classList.remove("hide") : "";
                            } else {
                                phone.classList.add("error");
                                var errorCode = iti.getValidationError();
                                errorMsg ? errorMsg.innerHTML = errorMap[errorCode] : "";
                                errorMsg ? errorMsg.classList.remove("hide") : "";
                            }
                        }
                        console.log(iti.getNumber(), "Le nimero de téléphone est ")
                    });

                    // on keyup / change flag: reset

                    phone.addEventListener('change', self.reset(errorMsg, validMsg, phone, hidden_field, iti));
                    phone.addEventListener('keyup', self.reset(errorMsg, validMsg, phone, hidden_field, iti));

                }
            });


        }

    }

    /**
     * @name  get_browser
     * @returns
     * Cette fonction permet de savoir le navigateur qu'utilise l'utilisateur
     */

    get_browser() {
        let ua = navigator.userAgent,
            tem,
            M =
                ua.match(
                    /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
                ) || [];
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return {name: "IE", version: parseInt(tem[1]) || ""};
        }
        if (M[1] === "Chrome") {
            tem = ua.match(/\bOPR|Edge\/(\d+)/);
            if (tem != null) {
                return {name: "Opera", version: parseInt(tem[1])};
            }
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1]);
        }
        return {
            name: M[0],
            version: parseInt(M[1]),
        };
    }


    reset(error, valid, phoneInput, hidden_field, iti) {

        phoneInput ? phoneInput.classList.remove("error") : "";
        error ? error.innerHTML = "" : "";
        error ? error.classList.add("hide") : "";
        valid ? valid.classList.add("hide") : "";
        hidden_field ? hidden_field.value = iti.getNumber() : "";


    };


    initZindex() {
        let index = [
            ...document.querySelectorAll("#mySidebar DIV"),
            ...document.querySelectorAll("#mySidebar INPUT"),
            ...document.querySelectorAll("#mySidebar I"),
            ...document.querySelectorAll("#mySidebar SPAN"),
            ...document.querySelectorAll("#mySidebar SMALL"),
            ...document.querySelectorAll("#mySidebar LABEL  "),
            ...document.querySelectorAll("#mySidebar A")
        ];

        for (let j = 0; j < index.length; j++) {
            index[j].style.zIndex = 100;
        }
    }

    toggle() {
        console.log("")
        if (this.isopened != 3) {
            this.initZindex()
            this.isopened = 3;
            this.fct($("#mySidebar").css("width") > "0px").then((res) => {
                if (res == true) {
                    this.isopened = 1;
                } else {
                    this.isopened = 0;
                }
            });
        } else {
            /*********/
        }
    }

    iniFla() {
        let fields = document.querySelectorAll(".flatpickr");

        for (let j = 0; j < fields.length; j++) {
            fields[j].classList.add("fx-input-date-sidbar-menu");
        }
    }

    fct(isopened) {
        return new Promise((resolve, reject) => {
            if (isopened) {
                this.closeNav().then(() => {
                    setTimeout(function () {
                        $("#mySidebar").css("position", "unset");
                        $("#main").css("position", "unset");
                        main.classList.remove("openbtn_left");
                        main.classList.add("openbtn_right");
                        $("#mySidebar").css("display", "none");
                        resolve(false);
                    }, 500);
                });
            } else {
                this.openNav().then(() => {
                    $("#mySidebar").css("position", "absolute");
                    $("#main").css("position", "absolute");
                    $("#main").css("marginTop", "0px");
                    $("#mySidebar").css("display", "block");
                    main.classList.add("openbtn_left");
                    main.classList.remove("openbtn_right");
                    resolve(true);
                });
            }
        });
    }

    openNav() {
        return new Promise((resolve, reject) => {
            document.getElementById("mySidebar").style.width = "366.8px";
            document.getElementById("main").style.marginRight = "366.8px";
            resolve(true);
        });
    }

    closeNav() {
        return new Promise((resolve, reject) => {
            document.getElementById("mySidebar").style.width = "0px";
            document.getElementById("main").style.margin = "0px";
            resolve(true);
        });
    }

    rerender() {
        var row = $("#search");
        var row2 = $("#quick_sort");
        row.insertAfter(row2);
    }

    /**
     * @name load_show_edit_destroy
     * Cette fonction permet d'afficher ou de cacher les boutons ajouter éditer est supprimé des lignes des tableaux de vueListe
     */
    load_show_edit_destroy() {
        var self = this;
        $(function () {
            self.show_edit_destroy_mouse_hover();
            $("#bd").change(function () {
                self.show_edit_destroy_mouse_hover();
            });
        });
    }


    /**
     * @name show_edit_destroy_mouse_hover
     * Cette fonction permet d'afficher ou de cacher les boutons ajouter éditer est supprimé des lignes des tableaux de vueListe
     */

    show_edit_destroy_mouse_hover() {

        $("#table1 tbody td:not(#search)").hover(


            function () {

                if ($(this).parents("tr").attr("id") != "search" && $(this).parents("tr").attr("id") != "pagination") {
                    $(this).parents("tr").addClass("highlight");
                }
            },
            function () {

                if ($(this).parents("tr").attr("id") != "search") {
                    $(this).parents("tr").removeClass("highlight");
                }
            }
        );

        // fonction du tableau pour cacher ou montrer les boutons actions par rangees
        $("a.edit").hide(); // cacher les liens avec la classe edit
        $("i.edit").hide(); // cacher les liens avec la classe edit
        $("img.edit").hide(); // cacher les liens avec la classe edit
        $("a.show").hide(); // cacher les liens avec la classe show
        $("i.show").hide(); // cacher les liens avec la classe show
        $("img.show").hide(); // cacher les liens avec la classe show
        $("a.destroy").hide(); // cacher les liens avec la classe destroy
        $("i.destroy").hide(); // cacher les liens avec la classe destroy
        $("img.destroy").hide(); // cacher les liens avec la classe destroy
        //
        // effet sur chaque rangee du tableau avec id

        $("#table1 tr:not(#search)").hover(
            function () {
                $(this).find("a.edit").addClass("selected").show();
                $(this).find("i.edit").addClass("selected").show();
                $(this).find("img.edit").addClass("selected").show();
                $(this).find("a.show").addClass("selected").show();
                $(this).find("i.show").addClass("selected").show();
                $(this).find("img.show").addClass("selected").show();
                $(this).find("a.destroy").addClass("selected").show();
                $(this).find("i.destroy").addClass("selected").show();
                $(this).find("img.destroy").addClass("selected").show();
            },
            function () {
                $(this).find("a.edit").removeClass("selected").hide();
                $(this).find("i.edit").removeClass("selected").hide();
                $(this).find("img.edit").removeClass("selected").hide();
                $(this).find("a.show").removeClass("selected").hide();
                $(this).find("i.show").removeClass("selected").hide();
                $(this).find("img.show").removeClass("selected").hide();
                $(this).find("a.destroy").removeClass("selected").hide();
                $(this).find("i.destroy").removeClass("selected").hide();
                $(this).find("img.destroy").removeClass("selected").hide();
            }
        );
    }


    initCheckbox() {


        console.log("Hello form initeCheckbox")


        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        })


        // $('select').selectric();


        /************************************
         *            Date Pickers			*
         ************************************/

        // Default
        $(".datepicker-default").datepicker();

        // Animations
        $(".datepicker-animation").datepicker();

        // ANimations dropdown change event
        $(".dp-animation").on("change", function () {
            $(".datepicker-animation").datepicker("option", "showAnim", $(this).val());
        });

        // Dates in other months
        $(".dp-other-month").datepicker({
            showOtherMonths: true,
            selectOtherMonths: true
        });

        // Display button bar
        $(".dp-button-bar").datepicker({
            showButtonPanel: true
        });

        // Display button bar
        $(".dp-inline").datepicker();

        // Display Month & Year Menu
        $(".dp-month-year").datepicker({
            changeMonth: true,
            changeYear: true
        });

        // Display Multiple Months
        $(".dp-multiple-months").datepicker({
            numberOfMonths: 3,
            showButtonPanel: true
        });

        // Constrain Input
        $(".dp-constrain-input").datepicker({
            constrainInput: true,
        });

        // Year Range
        $(".dp-year-range").datepicker({
            yearRange: "2015:2016"
        });

        // Step Months
        $(".dp-step-months").datepicker({
            stepMonths: 3
        });
        // Formate date
        $(".dp-format-date").datepicker();
        $(".date-formats").on("change", function () {
            $(".dp-format-date").datepicker("option", "dateFormat", $(this).val());
        });

        // Icon Trigger
        $(".dp-icon-trigger").datepicker({
            showOn: "button",
            buttonImage: "../../../app-assets/images/jqueryui/calendar.png",
            buttonImageOnly: true,
            buttonText: "Select date"
        });

        // Populate Alternate Field
        $(".dp-for-alternate").datepicker({
            altField: ".dp-alternate",
            altFormat: "DD, d MM, yy"
        });

        // Restrict Date Range
        $(".dp-date-range").datepicker({
            minDate: -20,
            maxDate: "+1M +10D"
        });

        // Show Week Of The Year
        $(".dp-week-year").datepicker({
            showWeek: true,
            firstDay: 1
        });

        // Select Date Range
        var dateFormat = "mm/dd/yy",
            from = $(".dp-date-range-from")
                .datepicker({
                    defaultDate: "+1w",
                    changeMonth: true,
                })
                .on("change", function () {
                    to.datepicker("option", "minDate", getDate(this));
                }),
            to = $(".dp-date-range-to").datepicker({
                defaultDate: "+1w",
                changeMonth: true,
            })
                .on("change", function () {
                    from.datepicker("option", "maxDate", getDate(this));
                });

        function getDate(element) {
            var date;
            try {
                date = $.datepicker.parseDate(dateFormat, element.value);
            } catch (error) {
                date = null;
            }

            return date;
        }

        // Apply Skin
        $('.ui-datepicker').wrap('<div class="dp-skin"/>');

        // For Bootstrap Checkbox

        $('.switch').checkboxpicker();


        // For Bootstrap Switches

        $('.switchBootstrap').bootstrapSwitch();
        var $html = $('html');
        // Switchery
        var i = 0;
        if (Array.prototype.forEach) {

            var elems = $('.switchery');
            $.each(elems, function (key, value) {
                var $size = "", $color = "", $sizeClass = "", $colorCode = "";
                $size = $(this).data('size');
                var $sizes = {
                    'lg': "large",
                    'sm': "small",
                    'xs': "xsmall"
                };
                if ($(this).data('size') !== undefined) {
                    $sizeClass = "switchery switchery-" + $sizes[$size];
                } else {
                    $sizeClass = "switchery";
                }

                $color = $(this).data('color');
                var $colors = {
                    'primary': "#365256",
                    'success': "#37BC9B",
                    'danger': "#DA4453",
                    'warning': "#F6BB42",
                    'info': "#3BAFDA",
                    'tertiary': "#3FB0AC"
                };
                if ($color !== undefined) {
                    $colorCode = $colors[$color];
                } else {
                    $colorCode = "#37BC9B";
                }

                var switchery = new Switchery($(this)[0], {className: $sizeClass, color: $colorCode});
            });
        } else {
            var elems1 = document.querySelectorAll('.switchery');

            for (i = 0; i < elems1.length; i++) {
                var $size = elems1[i].data('size');
                var $color = elems1[i].data('color');
                var switchery = new Switchery(elems1[i], {color: '#37BC9B'});
            }
        }


    }


    /* Application-wide lifecycle methods
     *
     * Use these methods to handle lifecycle concerns for the entire application.
     * Using the lifecycle is optional, so feel free to delete these stubs if you don't need them.
     *
     * Arguments:
     *
     *   element - the element that triggered the reflex
     *             may be different than the Stimulus controller's this.element
     *
     *   reflex - the name of the reflex e.g. "Example#demo"
     *
     *   error/noop - the error message (for reflexError), otherwise null
     *
     *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
     */


    beforeReflex(element, reflex, noop, reflexId) {
        //if ($('.lds-ring')) {
        //  $('.lds-ring').show();
        //}
        $("#loading_request").show();
    }

    afterReflex(element, reflex, noop, reflexId) {
        //if ($('.lds-ring')) {
        //$('.lds-ring').hide();
        //}
        $("#loading_request").hide();
    }

    reflexSuccess(element, reflex, noop, reflexId) {
        // show success message etc...
    }

    reflexError(element, reflex, error, reflexId) {
        // show error message etc...
    }
}